import EfSection from 'elem/ui/ef-section';
import EfSpec from 'elem/ui/ef-spec';
import EfTitle from 'elem/ui/ef-title';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('dp3.landing.EU6');
    const configs = {
        title: t('title'),
        desc: t('desc'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1739496757963/eu6.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1739496757963/eu6.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1739496757801/eu6_M.jpg',
    };

    return (
        <div className={`${css['thecomp']} GtmModuleData-section`} data-section-id={'dp3-EU6'} data-section-title={t('title')}>
            <EfSpec className="spec-x" />
            <EfTitle className="big-title" hasAnimation={false}>
                {t('bigTitle')}
            </EfTitle>
            <EfSpec className="spec-x" />
            <EfSection {...configs} hasAnimation={false} />
        </div>
    );
}
